import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'

type ProtocolPreviewType = 'handover' | 'return'
type ProtocolLanguage = 'sk' | 'en'

interface OfferProtocolPreviewParams {
  offerId: string
  protocolType: ProtocolPreviewType
  language: ProtocolLanguage
}

export function useOfferProtocolPreview() {
  const onError = useOnError()

  async function generatePreview({
    offerId,
    protocolType,
    language
  }: OfferProtocolPreviewParams) {
    const endpoint =
      protocolType === 'handover'
        ? `${SNA_PREFIX}offers/${offerId}/protocols/handover/preview/`
        : `${SNA_PREFIX}offers/${offerId}/protocols/return/preview/`

    const response = await apiClient.get<Blob>(endpoint, {
      params: { language },
      responseType: 'blob'
    })

    // Check if response is an error (JSON)
    if (response.data.type === 'application/json') {
      const text = await response.data.text()
      const errorData = JSON.parse(text)
      throw errorData
    }

    return response.data
  }

  return useMutation({
    mutationFn: generatePreview,
    onSuccess: (pdfBlob: Blob) => {
      const file = new Blob([pdfBlob], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },
    onError
  })
}
